import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import RenewalofExistingCourses from './ACCDTabs/RenewalofExistingCourses';
import AdditionalSectionsforExistingCourses from './ACCDTabs/AdditionalSectionsforExistingCourses';
import AffiliationforAdditionalCourses from './ACCDTabs/AffiliationforAdditionalCourses';
import PermanentAffiliationofExistingCourses from './ACCDTabs/PermanentAffiliationofExistingCourses';
import WithdrawlofExistingCourses from './ACCDTabs/WithdrawlofExistingCourses';
import ChangeofMedium from './ACCDTabs/ChangeofMedium';
import AddressChange from './ACCDTabs/AddressChange';
import ApproveAddCourses from './ACCDTabs/ApproveAddCourses';

function AffiliationCollegeCourseDetails2021() {
    const [activeTabIndex, setActiveTabIndex] = useState(0);


    return (
        <>
            <Tabs
                selectedIndex={activeTabIndex}
                onSelect={index => setActiveTabIndex(index)}
                forceRenderTabPanel={false}
            >
                <TabList className="tabs-container affl-tabcontainer">
                    <Tab className="tab">Renewal of Existing Courses</Tab>
                    <Tab className="tab">Additional Sections for Existing Courses</Tab>
                    <Tab className="tab">Affiliation for Additional Courses</Tab>
                    <Tab className="tab">Permanent Affiliation for Existing Courses</Tab>
                    <Tab className="tab">Withdrawal of Existing Courses</Tab>
                    <Tab className="tab">Change of Medium</Tab>
                    <Tab className="tab">Change of Address of College</Tab>
                    {/* <Tab className="tab">Add Courses that are Approved by CHE/University and Missing in Digital Affiliation Order</Tab> */}
                </TabList>
                <div className='imp-text text-end mb-4'>
                    <p className='mb-0'><a href='/AddingNewRenewalCourseDetails2021'>Add Courses that are Approved by CHE/University and Missing in Digital Affiliation Order</a></p>
                </div>
                <TabPanel>
                    <div className='tab-panel'>
                        <RenewalofExistingCourses />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <AdditionalSectionsforExistingCourses />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <AffiliationforAdditionalCourses />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <PermanentAffiliationofExistingCourses />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <WithdrawlofExistingCourses />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <ChangeofMedium />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className='tab-panel'>
                        <AddressChange />
                    </div>
                </TabPanel>
                {/* <TabPanel>
                    <div className='tab-panel' >
                        <ApproveAddCourses />
                    </div>
                </TabPanel> */}
            </Tabs>
        </>
    );
}

export default AffiliationCollegeCourseDetails2021;
